import React from 'react';
import { PlanCards } from './PlanCards';
import { Emoji } from './Emoji';
import { useCountdown } from '../hooks/useCountdown';
export function Oferta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section id="planes" className="w-full" data-id="element-135" data-mp="ji02ns5t07bz">
      <div className="w-full bg-[#1b0705] py-14" data-id="element-136" data-mp="3ivke3wnmyhn1">
        <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-137" data-mp="3ix3s1gltkgln">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-3xl" data-id="element-138" data-mp="3nuwx26bdz4kc">
            <Emoji symbol="⏰" data-id="element-139" data-mp="qh1lqvcb3cl" />
            Precio de lanzamiento — cierra en:
          </h2>

          <div className="mt-8 flex items-start justify-center gap-3 sm:gap-6" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-140" data-mp="1769i8ccfbyuo">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-141" data-mp="1irzdqqyo1ta8" data-mpi={index}>
                <div data-id="element-142" data-mp="1itand7eslv99">
                  <span className="block font-display text-[clamp(2.75rem,13vw,4.5rem)] font-black leading-none tabular-nums text-[#e04b3c]" data-id="element-143" data-mp="1dtfu4x7jotl1">
                    {unit.value}
                  </span>
                  <span className="mt-2 block font-display text-sm font-bold uppercase tracking-[0.14em] text-white/55" data-id="element-144" data-mp="14srdduqrof4g">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="font-display text-[clamp(2.75rem,13vw,4.5rem)] font-black leading-none text-[#e04b3c]" data-id="element-145" data-mp="v3pzca3s87t4">
                    :
                  </span> : null}
              </React.Fragment>)}
          </div>

          <p className="mt-8 inline-flex flex-wrap items-center justify-center gap-2 font-display text-lg font-bold text-white sm:text-xl" style={{
          fontSize: "14px"
        }} data-id="element-146" data-mp="h35el8eb41wz">
            <Emoji symbol="⚠️" data-id="element-147" data-mp="6gqqwzuj39dd" />
            Después sube <span className="text-[#e04b3c]" data-id="element-148" data-mp="bho5l2gbxla4">$10.000 ARS</span>. No
            vuelve.
          </p>

          <div className="mt-10" data-id="element-149" data-mp="3tnauk9fiavr7">
            <div className="flex items-center justify-between gap-4" data-id="element-150" data-mp="3toc7ykjzvuc3">
              <span className="inline-flex items-center gap-2 font-display text-sm font-bold text-[#e04b3c] sm:text-base" style={{
              fontSize: "12px"
            }} data-id="element-151" data-mp="2foo691ekf6n">
                <Emoji symbol="🔴" data-id="element-152" data-mp="q85ef6vandh1" />
                Cupos al precio de lanzamiento
              </span>
              <span className="font-display text-sm font-extrabold text-white sm:text-base" data-id="element-153" data-mp="u9gw8q7xeueo">
                Quedan pocos
              </span>
            </div>
            <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-154" data-mp="le17uopxx7gh">
              <span className="block h-full w-[72%] rounded-full bg-[#e04b3c]" data-id="element-155" data-mp="1n8m4l6rz0tgr" />
            </div>
            <p className="mt-3 text-right text-sm text-white/55" style={{
            fontSize: "12px"
          }} data-id="element-156" data-mp="1j8legoviettv">
              72% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="w-full bg-forest-900 py-16" data-id="element-157" data-mp="1s38et6mbgfz9">
        <div className="mx-auto max-w-[680px] px-5 sm:px-8" data-id="element-158" data-mp="14cm9vo7lzbth">
          <h2 className="text-center font-display text-3xl font-extrabold uppercase tracking-tight text-cream sm:text-4xl" data-id="element-159" data-mp="109zejdbqb8rj">
            Elegí tu <span className="text-lime-400" data-id="element-160" data-mp="1eas9u09uu7vp">Mega Pack</span>
          </h2>

          <div className="mt-12" data-id="element-161" data-mp="19axi5ui99e9l">
            <PlanCards data-id="element-162" data-mp="199w7vs92cvsx" />
          </div>
        </div>
      </div>
    </section>;
}